import type { EditorReactComponent } from '@wix/component-protocol/schema';

import { VirtualElementAPIType } from '../providers/VirtualElement';
import { AbstractManifestAPI } from '../AbstractManifestAPI';
import { ManifestResolverAPI } from '../../handlers';

/**
 * Owns the hard-contract "deprecated" rule, kept separate from the soft
 * display-filter intent in {@link ManifestDisplayFilterResolver}.
 *
 * A `deprecated: true` item flag is added by the component-protocol enricher
 * (re-added removed fields). EP owns hiding these from every panel — one rule
 * for all namespaces: `deprecated === true` ⇒ hide. Namespaces whose items
 * never carry the flag (e.g. actions) simply resolve to `false`. Unlike a
 * display filter, deprecation must override everything — including an explicit
 * `show` — so it is consulted before the display-filter check, never merged
 * with it.
 */
export class ManifestDeprecationResolver extends AbstractManifestAPI<
  ManifestResolverAPI,
  VirtualElementAPIType.ManifestResolver
> {
  isDeprecatedDefinition(
    editorElement: EditorReactComponent['editorElement'],
    namespace: string,
    key: string,
  ): boolean {
    const definitions = editorElement?.[
      namespace as keyof typeof editorElement
    ] as Record<string, { deprecated?: boolean }> | undefined;

    return definitions?.[key]?.deprecated === true;
  }

  isDeprecatedChild(child: { deprecated?: boolean }): boolean {
    return child.deprecated === true;
  }
}
